import { GridValidRowModel } from "@mui/x-data-grid-pro";

export interface IsolationRequestRow extends GridValidRowModel {
  id: number;
  selection: boolean;
  icon: string;
  isolationtypename: string;
  patientnamesurname: string;
  departmentname: string;
  doctorname: string;
  hospitalbedname: string;
  start_date: string;
  finish_date: string;
  approve_status: string;
  app_or_reject_date: string;
  app_user: string;
  approvalStyle?: {
  backgroundColor: string;
  opacity: number;
  };
}

export const IsolationRequestsRows: IsolationRequestRow[] = [
];